<template>
    <section class="mapa" v-loading="loading">

        <!-- Mapa -->
        <div class="contenedor-pasillos" v-if="this.mapa">

            <!-- Filtros -->
            <el-form :inline="true" @submit="getData">
                <el-form-item>
                    <el-input 
                        v-model="filtros.cod_articulo"
                        size="mini" 
                        placeholder="Código articulo">
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <el-input 
                        size="mini" 
                        v-model="filtros.lote" 
                        placeholder="Lote">
                    </el-input>
                </el-form-item>
                <el-form-item >
                    <el-date-picker
                        size="mini" 
                        v-model="filtros.caducidad"
                        type="date"
                        placeholder="Caducidad"
                        format="dd/MM/yyyy"
                        value-format="dd/MM/yyyy">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button
                        size="mini"
                        type="primary"
                        icon="el-icon-search"
                        @click="getData">
                        Buscar
                    </el-button>
                </el-form-item>
                <el-form-item>
                    <el-button 
                        size="mini"
                        type="default"
                        @click="resetearFiltros">
                        Limpiar filtros
                    </el-button>
                </el-form-item>
            </el-form>

            <div class="grupo-section">
                <div class="grupo" v-for="(grupo, g) in mapaGrupos" :key="`grupo_${g}`">

                    <div class="grafico">
                        <ul>
                            <template v-for="a in grupo.max_huecos">
                                <li v-if="!modoPares" :key="`polar_impg${g}g${a}`">{{ a }}</li>
                                <li v-else-if="a%2 == 1" :key="`impg${g}g${a}`">{{ a }}</li>
                            </template>
                        </ul>
                    </div>

                    <!-- PASILLOS MODO POLAR -->
                    <ul class="pasillos modo-polar" v-if="!modoPares">

                        <li 
                        v-for="(pasillo, p) in grupo.pasillos" 
                        :key="`grupo_${g}_pasillo_${p}`">

                            <b>{{ pasillo.key }}</b>

                            <div class="content-huecos">
                                <ul :class="['huecos', {'impar': pasillo.key%2 == 1}]">
                                    <li v-for="hueco in grupo.max_huecos"
                                        :key="`grupo_${g}_pasillo_${p}_hueco_${hueco}`"
                                        @click="selectHuecoPasillo(pasillo, hueco)"
                                        :data-id="hueco"
                                        :class="[{selected: selectHueco == hueco && selectPasillo.key === pasillo.key}]"
                                        :style="{backgroundColor: colorPorHueco(pasillo, hueco)}">
                                    </li>
                                </ul>
                            </div>
                            
                        </li>
                    </ul>

                    <!-- PASILLOS IMPAR/PAR -->
                    <ul class="pasillos" v-else>

                        <li v-for="(pasillo, p) in grupo.pasillos" :key="`grupo_${g}_pasillo_${p}`">

                            <b>{{ pasillo.key }}</b>

                            <div class="content-huecos">
                                <ul 
                                :class="['huecos', tipo]"
                                v-for="tipo in ['impar', 'par']"
                                :key="`tipo_${tipo}`">
                                    <template v-for="hueco in grupo.max_huecos">
                                        <li 
                                            v-if="tipo == 'par' ? hueco%2 == 1 : hueco%2 == 0"
                                            :key="`grupo_${g}_pasillo_${p}_hueco_${hueco}`"
                                            @click="selectHuecoPasillo(pasillo, hueco)"
                                            :data-id="hueco"
                                            :class="[{selected: selectHueco == hueco && selectPasillo.key === pasillo.key}]"
                                            :style="{backgroundColor: colorPorHueco(pasillo, hueco)}">
                                        </li>
                                    </template>
                                </ul>
                            </div>
                            
                        </li>
                    </ul>

                    <div class="grafico">
                        <ul>
                            <template v-for="a in grupo.max_huecos">
                                <li v-if="!modoPares" :key="`polar_parg${g}g${a}`">{{ a }}</li>
                                <li v-else-if="a%2 == 0" :key="`parg${g}g${a}`">{{ a }}</li>
                            </template>
                        </ul>
                    </div>

                </div>
            </div>
            
        </div>

        <!-- Detalle -->
        <div class="detalle">

            <ul v-if="detalle" class="alturas">

                <li 
                v-for="(altura, a) in detalle" 
                :key="`altura_${a}`">

                    <ul class="huecos">
                        <li 
                        v-for="(hueco, h) in altura" 
                        :key="`altura_${a}_hueco_${h}`"
                        @click="selectDetalleHueco({index: `${a}_${h}`, hueco})"
                        :style="{'width': `calc(100% / ${Object.keys(altura).length})`, 'height': `${15 * (hueco.ALTURA_HUECO * 3) }px`}"
                        :class="[{selected: detalleHueco.index == `${a}_${h}`}]">

                            <div 
                                class="carga"
                                :style="{top: `${100 - hueco.porcentaje}%`}">
                            </div>
                            
                        </li>
                    </ul>
                </li>
            </ul>
            <p v-else>Selecciona el hueco de un pasillo</p>
        </div>

        <!-- Detalle -->
        <div class="detalle">
            <div class="description" :style="{visibility: detalle && detalleHueco && detalleHueco.hueco ? 'visible' : 'hidden'}">

                <template v-if="detalle && detalleHueco && detalleHueco.hueco">

                    <!-- Detalle Hueco -->
                    <ul>
                        <li>
                            <span>{{ selectPasillo.key || '-' }}</span>
                            <p>PASILLO</p>
                        </li>
                        <li>
                            <span>{{ selectHueco || '-' }}</span>
                            <p>ESTANTERIA</p>
                        </li>
                        <li>
                            <span>{{ detalleHueco.hueco.ALTURA || '-' }}</span>
                            <p>ALTURA</p>
                        </li>
                        <li>
                            <span>{{ detalleHueco.hueco.POSICION || '-' }}</span>
                            <p>HUECO</p>
                        </li>
                    </ul>

                    <!-- Articulos -->
                    <ul class="articulos" v-if="detalleHueco.articulos.length">
                        <li v-for="(articulo, a) in detalleHueco.articulos" :key="`art_${a}`">

                            <b v-if="articulo.picking">PICKING</b>

                            <p v-if="articulo.codigo && articulo.nombre">{{ articulo.codigo }} - <b>{{ articulo.nombre }}</b></p>

                            <!-- Bultos -->
                            <div class="bulto" v-for="(bulto, b) in articulo.bultos" :key="`bulto_${b}`">

                                <div v-if="bulto.stock" class="stock">Stock: <b>{{ bulto.stock }}</b></div>

                                <div class="bulto-wraper">
                                    <div class="bulto-content">
                                        <div class="bulto-entrada" >
                                            <p>Fecha entrada</p>
                                            <span>{{ bulto.fecha_entrada }}</span>
                                        </div>
                                        <div class="bulto-lote" :style="{visibility: bulto.lote ? 'visible' : 'hidden'}">
                                            <p>Lote</p>
                                            <span>{{ bulto.lote }}</span>
                                        </div>
                                        <div class="bulto-entrada" :style="{visibility: bulto.fecha_caducidad ? 'visible' : 'hidden'}">
                                            <p>Fecha caducidad</p>
                                            <span>{{ bulto.fecha_caducidad }}</span>
                                        </div>
                                    </div>
                                    <button @click="goBulto(bulto)">
                                        <i class="el-icon-right"></i>
                                    </button>
                                </div>
                                
                            </div>
                        </li>
                    </ul>
                    <div 
                    v-else 
                    style="
                        text-align: center;
                        display: flex;
                        justify-content: center;
                        background-color: #ffcaca;
                        color: #4d0000b5;
                        padding: 5px;
                    ">
                        No hay bultos
                    </div>

                </template>
            </div>
        </div>
    </section>
</template>

<script>

    let colores = {
    "0": "#6FCB72",
    "1": "#FFB916",
    "2": "#FFBE1D",
    "3": "#FFC323",
    "4": "#FFC82A",
    "5": "#FFCE31",
    "6": "#FFD338",
    "7": "#FFD83E",
    "8": "#FFDE45",
    "9": "#FFE44C",
    "10": "#FFE953",
    "11": "#FFEF59",
    "12": "#FFF460",
    "13": "#FFF967",
    "14": "#FFFF6E",
    "15": "#FFFF75",
    "16": "#FFFF7B",
    "17": "#FFFF82",
    "18": "#FFFF89",
    "19": "#FFFF90",
    "20": "#FFFF97",
    "21": "#FFFF9D",
    "22": "#FFFFA4",
    "23": "#FFFFAB",
    "24": "#FFFFB1",
    "25": "#FFFFB8",
    "26": "#FFFFBF",
    "27": "#FFFFC5",
    "28": "#FFFFCC",
    "29": "#FFFFD3",
    "30": "#FFFFD9",
    "31": "#FFFFE0",
    "32": "#FFFFE7",
    "33": "#FFFFED",
    "34": "#FFFFF4",
    "35": "#FFFFFB",
    "36": "#FFFBF6",
    "37": "#FFF6F1",
    "38": "#FFF1ED",
    "39": "#FFECE8",
    "40": "#FFE7E3",
    "41": "#FFE2DE",
    "42": "#FFDDD9",
    "43": "#FFD8D4",
    "44": "#FFD3CF",
    "45": "#FFCECA",
    "46": "#FFC9C6",
    "47": "#FFC4C1",
    "48": "#FFBFBC",
    "49": "#FFBAB7",
    "50": "#FFB5B2",
    "51": "#FFB0AD",
    "52": "#FFABA8",
    "53": "#FFA6A3",
    "54": "#FFA19F",
    "55": "#FF9C9A",
    "56": "#FF9795",
    "57": "#FF9290",
    "58": "#FF8D8B",
    "59": "#FF8886",
    "60": "#FF8381",
    "61": "#FF7E7C",
    "62": "#FF7977",
    "63": "#FF7472",
    "64": "#FF6F6D",
    "65": "#FF6A68",
    "66": "#FF6563",
    "67": "#FF605E",
    "68": "#FF5B5A",
    "69": "#FF5655",
    "70": "#FF5150",
    "71": "#FF4C4B",
    "72": "#FF4746",
    "73": "#FF4241",
    "74": "#FF3D3C",
    "75": "#FF3837",
    "76": "#FF3332",
    "77": "#FF2E2D",
    "78": "#FF2928",
    "79": "#FF2424",
    "80": "#FF1F1F",
    "81": "#FF1A1A",
    "82": "#FF1515",
    "83": "#FF1010",
    "84": "#FF0B0B",
    "85": "#FF0606",
    "86": "#FF0101",
    "87": "#FF0003",
    "88": "#FF0006",
    "89": "#FF0009",
    "90": "#FF000C",
    "91": "#FF000F",
    "92": "#FF0012",
    "93": "#FF0015",
    "94": "#FF0018",
    "95": "#FF001B",
    "96": "#FF001E",
    "97": "#FF0021",
    "98": "#FF0024",
    "99": "#FF0027",
    "100": "#BF0E2F"
    }

    import {
        getDataMapaAlmacen,
        getDataMapaAlmacenHuecos,
        getDataMapaAlmacenHueco
    } from '@/helpers/api'

	export default {
        name: 'MapaAlmacen',
        props: {
            id: String,
            ficha: Object,
            entidad: String,
            porlet: Object,
            currentAction: Object,
            reload: {
                type: Boolean,
                required: false,
                default: () => false
            },
            autoReload: {
                type: Boolean,
                required: false,
                default: () => false
            }
        },
		data () {
			return {
                loading: false,
                error: null,
                mapa: null,
                detalle: null,
                detalleHueco: {},
                colores,
                filtros: {
                    cod_articulo: '',
                    lote: '',
                    caducidad: ''
                },
                modoPares: true,
                almacen_id: false,
                selectPasillo: '',
                selectHueco: ''
            }
        },
        computed: {
            mapaGrupos() {

                if (!this.mapa) return

                return this.mapa
                
            }
        },
        mounted() {

            if(this.porlet.attr.hasOwnProperty('modoPares')) this.modoPares = this.porlet.attr.modoPares
            if(this.porlet.attr.hasOwnProperty('almacen_id')) this.almacen_id = this.porlet.attr.almacen_id

            this.getData()

            this.$emit('created')
        },
        methods: {
            async getData() {

                if (this.loading) return

                this.loading = true
                
                this.error = false
                
                try {

                    let {data} = await getDataMapaAlmacen({
                        almacen_id: this.almacen_id, 
                        ...this.filtros
                    })
                    
                    this.mapa = data

                } catch(err) {

                    this.error = true
                }

                this.loading = false
            },
            refresh() {
                this.getData()
            },
            async selectHuecoPasillo(pasillo, hueco) {

                let huecoExist = pasillo.huecos.find(f => f.key == hueco)

                if (!huecoExist) return

                if (this.loading) return

                this.loading = true

                this.error = false

                try {

                    let {data} = await getDataMapaAlmacenHuecos(pasillo.key, hueco, {
                        almacen_id: this.almacen_id,
                        ...this.filtros
                    })
                    
                    let obj = {}
                    for(let i = Number(Object.keys(data)[Object.keys(data).length - 1]); i > 0; i--) {
                        obj[`_${i}`] = data[i] || {}
                    }
                    /*Object.keys(data).reverse().forEach(key => {
                        obj[`_${key}`] = data[key]
                    })*/
                    
                    this.detalleHueco = {}

                    this.detalle = obj

                    this.selectPasillo = pasillo
                    this.selectHueco = hueco

                } catch(err) {

                    this.error = true
                }

                this.loading = false
            },
            async selectDetalleHueco(hueco) {
               
                try {

                    let {data} = await getDataMapaAlmacenHueco({
                        hueco: this.selectHueco,
                        pasillo: this.selectPasillo.key,
                        altura: hueco.hueco.ALTURA,
                        posicion: hueco.hueco.POSICION
                    })
                    this.detalleHueco = {
                        ...hueco, 
                        articulos: data
                    }

                } catch (e) {

                    console.log('Error selectDetalleHueco', e)
                }
                
            },
            // Ir a la ficha del bulto
            goBulto(bulto) {
                window.open(`${window.distributionapp.publicPath}/#/sga_bultos/${bulto.id}`)
            },
            // Utils
            groupBy(xs, key) {
                return xs.reduce(function(rv, x) {
                    (rv[x[key]] = rv[x[key]] || []).push(x);
                    return rv;
                }, {});
            },
            colorPorHueco(pasillo, hueco) {

                let huecoExist = pasillo.huecos.find(f => f.key == hueco)

                return huecoExist ? this.colores[huecoExist.value] : 'transparent'
            },
            pasillosPares(pasillos) {

                return pasillos.reduce((acum, obj) => {

                    let pasillosPares = obj.huecos.filter(f => f.key%2 === 1)

                    if (pasillosPares.length > acum.length) return pasillosPares

                    return acum

                }, [])
            },
            pasillosImpares(pasillos) {

                let lista = pasillos.reduce((acum, obj) => {

                    let pasillosImpares = obj.huecos.filter(f => f.key%2 === 0)

                    if (pasillosImpares.length > acum.length) return pasillosImpares

                    return acum

                }, [])

                return lista
            },
            resetearFiltros() {
                
                this.filtros.cod_articulo = ''
                this.filtros.lote = ''
                this.filtros.caducidad = ''

                this.getData()
            }
        }
	}
</script>

<style lang="scss">
section.mapa {
    overflow: hidden;
    height: 100%;
    background-color: #ecf5ff;
    display: flex;

    .contenedor-pasillos {
        display: flex;
        flex-flow: column;
        border-right: 1px solid #d2d2d2;
        padding: 25px;
        flex-grow: 1;

        form {
            display: flex;
            justify-content: flex-end;
        }
        .grupo-section {
            overflow: auto;
            height: calc(100vh - 162px);

            .grupo {
                display: flex;
                align-items: flex-end;
                margin-bottom: 40px;
                justify-content: center;
                
                .grafico {
                    display: flex;
                    flex-flow: column;
                    justify-content: space-between;
                    ul {
                        list-style: none;
                        margin: 0px;
                        padding: 0px 10px;
                        display: flex;
                        flex-flow: column-reverse;
                        li {
                            width: 20px;
                            height: 13px;
                            text-align: center;
                            border: 1px solid #ecf5ff;
                            font-size: 0.6rem;
                        }
                    }
                }

                ul.pasillos {
                    margin: 0px;
                    padding: 0px;
                    list-style: none;
                    display: flex;
                    flex-wrap: wrap;
                    width: 740px;
                    
                    > li {
                        display: flex;
                        align-items: center;
                        flex-flow: column;
                        min-width: 71px;
                        justify-content: space-between;

                        > b {
                            margin-bottom: 10px;
                        }

                        .content-huecos {
                            display: flex;
                            flex-flow: row-reverse;

                            > ul.huecos {
                                margin: 0px;
                                padding: 0px;
                                list-style: none;
                                display: flex;
                                flex-flow: column-reverse;
                                border: 1px solid #585858;
                                margin: 0px;
                                &:first-child {
                                    margin-left: 30px;
                                }
                                > li {
                                    background-color: white;
                                    border-bottom: 1px solid black;
                                    padding: 7px 10px;
                                    font-size: 0.7rem;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    cursor: pointer;

                                    &:first-child {
                                        border: 0px;
                                    }

                                    &.selected {
                                        z-index: 9;
                                        box-shadow: 0px 6px 20px 7px rgba(0,0,0,0.82);
                                    }
                                    
                                }
                            }
                        } 
                    }

                    &.modo-polar {
                        li {
                            min-width: auto;
                            align-items: normal;
                                    
                            .content-huecos {
                                > ul.huecos {
                                    &.impar {
                                        margin-right: 30px!important;
                                    }
                                    &:first-child {
                                        margin-left: 0px;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        
    }

    .detalle {
        flex-grow: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-flow: column;
        max-width: 600px;
        max-height: 100vh;

        > .description {
            background-color: white;
            width: 400px;
            border-radius: 8px;
            margin-bottom: 10px;
            padding: 10px;
            border: 1px solid #dedede;
            min-height: 150px;
            overflow: scroll;
            max-height: 600px;
            overflow-x: hidden;

            > h2 {
                margin: 0px;
                font-size: 1.3rem!important;
            }

            > b {
                margin-bottom: 5px;
                display: block;
                color: #b2b2b2;
            }

            > ul {
                margin: 0px;
                padding: 0px;
                list-style: none;
                display: flex;
                justify-content: space-between;
                margin-bottom: 10px;
                li {
                    min-width: 78px;
                    display: flex;
                    flex-flow: column;
                    border-right: 1px solid #e0e0e0;
                    border-radius: 7px;
                    border: 1px solid #e0e0e0;
                    background-color: #f8f8f8;
                    align-items: center;
                    justify-content: center;
                    padding: 5px 0px;
                    > span {
                        font-size: 1.4rem;
                        font-weight: 200;
                    }
                    > p { 
                        margin: 0px;
                        font-size: 0.7rem;
                    }
                }
            }

            >  div {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-top: 10px;
                > p{
                    margin: 5px 0px;
                }
            }
        }

        > ul.alturas {
            margin: 0px;
            padding: 0px;
            list-style: none;
            border-left: 3px solid #6e6e6e;
            border-bottom: 5px solid #6e6e6e;
            border-right: 3px solid #6e6e6e;
            width: 440px;
            transform: scale(0.7);

            li {
                margin-bottom: 20px;
                &:last-child {
                    margin-bottom: 0px;
                    ul.huecos {
                        border: 0px;
                    }
                }

                > ul.huecos {
                    margin: 0px;
                    padding: 0px 5px;
                    list-style: none;
                    display: flex;
                    gap: 5px;
                    border-bottom: 5px solid #6e6e6e;
                    align-items: flex-end;

                    li {
                        padding: 2px;
                        border: 1px solid #E6A23C;
                        background-color: rgb(250, 236, 216);
                        margin-bottom: 5px;
                        height: 15px;
                        cursor: pointer;
                        position: relative;
                        .carga {
                            position: absolute;
                            background-color: #00000014;
                            left: 0;
                            right: 0;
                            bottom: 0;
                            top: 50%;
                        }
                        &:hover {
                            background-color: rgb(252, 215, 165);
                        }
                        &.selected {
                            background-color: #ffc626 !important;
                            border: 3px solid black;
                            box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);
                        }
                    }
                }
            }
        }
        
        ul.articulos {
            display: flex;
            flex-flow: column;
            margin-bottom: 0px;
            li {
                margin-bottom: 10px;
                align-items: flex-start;
                padding: 10px;
                > b {
                    font-size: 0.7rem;
                    text-decoration: underline;
                    margin-bottom: 5px;
                }
                > p {
                    font-weight: bold;
                    margin-bottom: 5px;
                    b {
                        text-transform: uppercase;
                    }
                }
                .bulto {
                    display: flex;
                    width: -webkit-fill-available;
                    justify-content: space-between;
                    margin-bottom: 5px;
                    flex-flow: column;
                    &:last-child {
                        margin-bottom: 0px;
                    }
                    .stock {
                        font-size: 0.8rem;
                        margin-bottom: 3px;
                    }
                    .bulto-wraper {
                        display: flex;
                        width: -webkit-fill-available;
                        justify-content: space-between;

                        .bulto-content {
                            display: flex;
                            border: 1px solid lightgrey;
                            flex-grow: 1;
                            margin-right: 10px;
                            padding: 5px;
                            justify-content: space-between;
                            .bulto-entrada,
                            .bulto-lote,
                            .bulto-caducidad {
                                p {
                                    margin: 0px;
                                    font-size: 0.7rem;
                                    text-align: center;
                                }
                                span {
                                    font-size: 0.7rem;
                                    text-align: center;
                                    font-weight: bold;
                                    display: block;
                                }
                            }
                        }

                        button {
                            display: flex;
                            align-items: center;
                            border-radius: 4px;
                            border: 1px solid #9f9f9f;
                            background-color: #d5d5d5;
                            color: #474747;
                            font-size: 1.2rem;
                            cursor: pointer;
                            &:hover {
                                background-color: #b7b7b7;
                            }
                        }
                    }
                    
                }
                &:last-child {
                    margin-bottom: 0px;
                }
            }
        }
        
    }
    
}
</style>